import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {OrdsHttpClient} from './ords-http-client';

export interface UploadResult {
  upld_filex: string;
  upld_filex_in_host: string;
  file_size: string;
  file_hash: string;
  ret_msg: string;
  status_code: string;
}

const docPath = (): string => {
  const loc = window.location.href;
  if (loc.indexOf('localhost') > -1) {
    return '';
  }
  // prod
  // TODO - move to environment.ts
  // TODO - get URL from ORDS by calling xoutGWBKUPLD(pApplID => pApplID);
  if (loc.indexOf('banweb.cityu.edu.hk') > -1) {
    return 'https://banstudoc.cityu.edu.hk';
  }
  // dev
  return 'https://banstudocdev.cityu.edu.hk';
};

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  private uploadUrl = `${docPath()}/gwbkupldcgi/gwbkupld_cityu_json.pl?hostelwww_hg`;

  constructor(private http: HttpClient,
              private ords: OrdsHttpClient) {
  }

  upload(file: File): Observable<UploadResult> {
    const form = new FormData();
    form.append('upld_filex', file);
    return this.http.post<UploadResult>(this.uploadUrl, form).pipe(tap((res: UploadResult) => {
      if (res.status_code !== 'S') {
        throw new Error(`Upload failed: ${res.ret_msg}`);
      }
    }));
  }

  viewDoc(path: string): Observable<Blob> {
    return this.ords.get(`/doc/${path}`, {responseType: 'blob'});
  }
}
